const INJECTED_WEB_VITALS_MESSAGE =
  "Cannot read properties of undefined (reading 'startTime')";
const NUXT_BUILD_META_PATH_PATTERN =
  /\/_nuxt\/builds\/meta\/[0-9a-f-]+\.json(?:[?#]\S*)?/i;
const NETWORK_FETCH_FAILURE_PATTERN =
  /(?:<no response>|failed to fetch|fetch failed|load failed|networkerror|network error|err_failed|err_network)/i;

const MONITORING_EVIDENCE_KEYS = new Set([
  'exception',
  'file',
  'filename',
  'frames',
  'function',
  'functionName',
  'message',
  'reason',
  'source',
  'stack',
  'stacktrace',
  'type',
  'value',
  'values',
]);

const collectMonitoringEvidence = (
  value: unknown,
  parts: string[],
  seen: Set<object>,
  depth = 0,
): void => {
  if (depth > 6 || value === null || value === undefined) {
    return;
  }

  if (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean'
  ) {
    parts.push(String(value));
    return;
  }

  if (typeof value !== 'object' || seen.has(value)) {
    return;
  }

  seen.add(value);

  if (value instanceof Error) {
    parts.push(value.name, value.message, value.stack ?? '');
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((item) =>
      collectMonitoringEvidence(item, parts, seen, depth + 1),
    );
    return;
  }

  for (const [key, item] of Object.entries(value)) {
    if (MONITORING_EVIDENCE_KEYS.has(key)) {
      collectMonitoringEvidence(item, parts, seen, depth + 1);
    }
  }
};

export const isInjectedWebVitalsStartTimeError = (
  error: unknown,
  context: Record<string, unknown> = {},
): boolean => {
  const parts: string[] = [];
  const seen = new Set<object>();

  collectMonitoringEvidence(error, parts, seen);
  collectMonitoringEvidence(context, parts, seen);

  const evidence = parts.join('\n');

  return (
    evidence.includes(INJECTED_WEB_VITALS_MESSAGE) &&
    evidence.includes('reportAllChanges') &&
    /(?:<anonymous>|\bVM\d+(?::\d+)?\b)/.test(evidence)
  );
};

export const isNuxtBuildMetaFetchError = (
  error: unknown,
  context: Record<string, unknown> = {},
): boolean => {
  const parts: string[] = [];
  const seen = new Set<object>();

  collectMonitoringEvidence(error, parts, seen);
  collectMonitoringEvidence(context, parts, seen);

  const evidence = parts.join('\n');

  return (
    NUXT_BUILD_META_PATH_PATTERN.test(evidence) &&
    NETWORK_FETCH_FAILURE_PATTERN.test(evidence)
  );
};
